import './layout.less';
import { Layout, LayoutSidebar, LayoutContent } from './layout';
import Header from './header';
import Footer from './footer';
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = LayoutContent;
Layout.Sider = LayoutSidebar;
export default Layout;